import * as React from "react";

const ArrowRight: React.FC = () => {
    return <svg width="16px" height="14px" viewBox="0 0 16 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="3.-Style" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1.Iconography" transform="translate(-208.000000, -360.000000)" fill="currentColor">
            <g transform="translate(79.000000, 230.000000)">
                <g transform="translate(129.000000, 130.000000)">
                    <polygon points="12.6 6 0 6 0 8 12.7 8 7.7 12.7 9 14 16 7 9 0 7.7 1.3"></polygon>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(ArrowRight);
